import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-linkedin-icon',
  templateUrl: 'linkedin-icon.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class LinkedinIconComponent {
}

